<template>
  <div
    class="t-notification"
    :class="[
      `t-notification--${type}`,
      { 't-notification--dismissable': dismissable },
    ]"
    @click="close"
    @mouseover="onMouseover"
    @mouseleave="onMouseleave"
  >
    <div class="t-notification__prefix">
      <t-icon v-if="icon" :icon="icon"></t-icon>
    </div>
    <div class="t-notification__body">
      <span><slot></slot></span>
    </div>
  </div>
</template>

<script>
import { TIcon } from '../TIcon';
import ColorTypeMixin from '../../mixins/ColorTypeMixin';

export default {
  name: 't-notification',

  mixins: [ColorTypeMixin],

  props: {
    icon: {
      type: [String, Array],
      default: null,
    },

    dismissable: {
      type: Boolean,
      default: true,
    },

    autoDismissing: {
      type: Boolean,
      default: true,
    },

    timeout: {
      type: Number,
      default: 8000,
    },
  },

  data() {
    return {
      dismissing: null,
    };
  },

  created() {
    if (this.autoDismissing) {
      this.startTimeout();
    }
  },

  beforeDestroy() {
    if (this.dismissing) {
      this.stopTimeout();
    }
  },

  methods: {
    startTimeout() {
      this.dismissing = setTimeout(() => {
        this.close();
      }, this.timeout);
    },

    stopTimeout() {
      clearTimeout(this.dismissing);
    },

    onMouseover() {
      this.stopTimeout();
    },

    onMouseleave() {
      this.startTimeout();
    },

    close(e) {
      // disallow closing on click when notification is not dismissable
      if (!this.dismissable && e?.target) return;
      this.$emit('closed');
    },
  },

  components: {
    TIcon,
  },
};
</script>
